import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SmoothScroll from "@/components/SmoothScroll";

function ScrollToTop() {
  const { pathname, state } = useLocation();
  useEffect(() => {
    if (state && state.scrollTo) return; // Home handles targeted scroll
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, state]);
  return null;
}

export default function Layout() {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <SmoothScroll />
      <ScrollToTop />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
